<template>
  <v-card>
    <v-card-title>
      <div>
        <h3 class="headline">Create new user</h3>
      </div>
    </v-card-title>

    <v-card-text>
      <v-form ref="form" @submit.prevent="createUser" lazy-validation>
        <v-text-field v-model="name" label="Name" required :rules="[v => !!v || 'Required field']"></v-text-field>
        <v-text-field
          v-model="email"
          label="Email Address"
          required
          :rules="[v => !!v || 'Required field']"
        ></v-text-field>
        <v-text-field
          v-model="password"
          label="Password"
          required
          :rules="[v => !!v || 'Required field']"
        ></v-text-field>

        <v-btn type="submit" color="info">Create user</v-btn>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { FirebaseAuth, Database, config } from '@/library/firebase'

import Firebase from 'firebase/app'

const FirebaseUser = Firebase.initializeApp(config, "UserAdmin")
const FirebaseUserAuth = FirebaseUser.auth()

export default {
  data () {
    return {
      name: '',
      email: '',
      password: ''
    }
  },
  methods: {
    createUser () {
      if (this.$refs.form.validate()) {
        FirebaseUserAuth.createUserWithEmailAndPassword(this.email, this.password)
          .then(data => {
            Database.ref('users').child(data.user.uid).set({
              email: this.email,
              name: this.name
            })

            this.$toasted.success('User created!')
            this.$router.push({ name: 'backend-user', params: { id: data.user.uid } })
          })
          .catch(e => {
            this.$toasted.error(e)
          })
      }
    }
  }
}
</script>

<style>
</style>
